import { render, staticRenderFns } from "./MicrocartIcon.vue?vue&type=template&id=54e6752a&"
import script from "./MicrocartIcon.vue?vue&type=script&lang=js&"
export * from "./MicrocartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports